<template>
    <b-form-checkbox
        @change="input"
        :checked="checked"
        :id="id"
        :name="name"
    >
         {{ label }}
    </b-form-checkbox>
</template>

<script>
export default {
    name: 'SelectAllCheckbox',

    props: {
        deselectValue: {
            default: () => ([]),
            required: false,
            type: Array,
        },
        id: {
            default: 'select-all',
            required: false,
            type: String,
        },
        label: {
            default: 'Select All',
            required: false,
            type: String,
        },
        name: {
            default: 'select-all-button',
            required: false,
            type: String,
        },
        selectValue: {
            required: true,
            type: Array,
        },
        value: {
            required: true,
            type: Array,
        },
    },

    computed: {
        checked() {
            return this.selectValue.filter(value => this.value.includes(value)).length === this.selectValue.length;
        },
    },

    methods: {
        input(checked) {
            this.$emit('input', checked ? this.selectValue : this.deselectValue);
            checked
                ? this.$emit('selected', this.selectValue)
                : this.$emit('deselected', this.deselectValue);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/CheckboxComponents/SelectAllCheckbox.vue